import SiafLiteApiRepository from "../../external/siafLiteApi";

class TerceirizadosService {
  constructor() {
    this.urlBase = "/estoque/terceirizados";
    this.urlBaseEvent = `/event${this.urlBase}`;
  }

  getAll(filter) {
    return new SiafLiteApiRepository(this.urlBaseEvent).get(filter);
  }

  upsert(body) {
    return new SiafLiteApiRepository(`${this.urlBaseEvent}/upsert`).post(body);
  }
}

export default TerceirizadosService;
